define('ua/listeners/cities',['ua/ua-wrapper'], function(ua) {
    'use strict';

    /*
     * COREUI-469
     *
     * EVENTS:
     *  cities.nav.click
     *  cities.search.click
     *  cities.guide.click
     *  cities.map.expand
     *  cities.map.zoom
     *
     *  cities.viewrentals.click
     *  cities.gogobot.click
     *  cities.experience.click
     *  cities.poi.click
     *  cities.morepoi.click
     *  cities.featuredlisting.click
     *  cities.viewall.click
     *  cities.map.pin.poi.click
     *  cities.map.filter.click
     *
     *  cities.property.click
     *  cities.map.pin.property.click
     */
    function setupListeners(edap) {
        var adl = edap.getDL(),
            category = 'cities',
            collectionStr = 'collection:',
            guideStr = 'guide:',
            pagenameType;

        if (adl.pagetype === 'marketing' && adl.pagename) {
            if (adl.pagename.indexOf('city-collection') !== -1) {
                pagenameType = collectionStr;
            } else if (adl.pagename.indexOf('city-guide') !== -1) {
                pagenameType = guideStr;
            }
        }

        // City Collection events
        if (pagenameType === collectionStr) {
            edap.on('cities.nav.click', function(data) {
                ua.sendEvent(category, collectionStr + 'nav', data.citycode);
            });

            edap.on('cities.search.click', function(data) {
                ua.sendEvent(category, collectionStr + 'search:' + data.actionlocation, data.citycode);
            });

            edap.on('cities.guide.click', function(data) {
                ua.sendEvent(category, collectionStr + 'cityguide', data.citycode);
            });

            edap.on('cities.map.expand', function(data) {
                ua.sendEvent(category, collectionStr + 'mapexpand', data.citycode);
            });

            edap.on('cities.map.zoom', function(data) {
                ua.sendEvent(category, collectionStr + 'mapzoom:' + data.zoomtype, data.citycode);
            });

        // City Guide events
        } else if (pagenameType === guideStr) {
            edap.on('cities.viewrentals.click', function(data) {
                ua.sendEvent(category, guideStr + 'viewrentals', data.citycode);
            });

            edap.on('cities.gogobot.click', function(data) {
                ua.sendEvent(category, guideStr + 'gogobotlogo', data.citycode);
            });

            edap.on('cities.experience.click', function(data) {
                ua.sendEvent(category, guideStr + 'experience:' + data.eventname, data.citycode);
            });

            edap.on('cities.poi.click', function(data) {
                ua.sendEvent(category, guideStr + 'poi:' + data.eventname, data.citycode);
            });

            edap.on('cities.morepoi.click', function(data) {
                ua.sendEvent(category, guideStr + 'morepoi', data.citycode);
            });

            edap.on('cities.featuredlisting.click', function(data) {
                ua.sendEvent(category, guideStr + 'featuredlisting:' + data.actionlocation, data.citycode);
            });

            edap.on('cities.viewall.click', function(data) {
                ua.sendEvent(category, guideStr + 'viewall', data.citycode);
            });

            edap.on('cities.map.pin.poi.click', function(data) {
                ua.sendEvent(category, guideStr + 'poipin', data.citycode);
            });

            edap.on('cities.map.filter.click', function(data) {
                ua.sendEvent(category, guideStr + 'mapfilter:' + data.eventname + ':' + data.actionstate, data.citycode);
            });
        }

        // City Collection AND City Guide event
        if (pagenameType === guideStr || pagenameType === collectionStr) {
            edap.on('cities.map.pin.property.click', function(data) {
                ua.sendEvent(category, pagenameType + 'propertypin', data.citycode);
            });

            edap.on('cities.property.click', function(data) {
                ua.sendEvent(category, pagenameType + 'propertylink', data.citycode);
            });

            edap.on('owner.lyp.click', function(data) {
                ua.sendEvent(category, pagenameType + 'lyp', data.citycode);
            });
        }
    }


    return {
        setupListeners: setupListeners
    };
});

